import { Box, Typography, useMediaQuery } from '@mui/material';
import FilterIdentifierPanel from 'feature/loading-management/filters/filter-identifier-panel/FilterIdentifierPanel.connector';
import { bool, element, string } from 'prop-types';
import React from 'react';

const Heading = ({ headerButtons, listTabs, showTabs, title }) => {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });

  return lgUp ? (
    <Box bgcolor="surface.light" position="sticky" top={48} zIndex={2}>
      <>
        <Box alignItems="center" display="flex" pl={3} pr={2} py={3}>
          <Typography sx={{ margin: 'auto auto auto 0' }} variant="h5">
            {title}
          </Typography>
          {headerButtons}
        </Box>
      </>
      {showTabs && listTabs}
      <FilterIdentifierPanel />
    </Box>
  ) : (
    showTabs && listTabs
  );
};

Heading.propTypes = {
  headerButtons: element,
  listTabs: element,
  showTabs: bool,
  title: string.isRequired,
};

Heading.defaultProps = {
  headerButtons: null,
  listTabs: null,
  showTabs: false,
};

export default Heading;
